import { ISociosChart } from "../../interfaces/SociosChart";
import { ChartContainerLoader, HighChart } from "../Generic/Charts";

interface PieChartProps {
  chartName: string;
  chartSeriesName?: string;
  cantidadLabel?:string,
  data: ISociosChart[];
  colSize?: string;
  setTipoContraparteFiltrada?: (tipoContraparte: number) => void;
  setContraparteSeleccionada?: (contraparteSeleccionada?: number) => void;
}

export interface GraphDataItem {
  y: number;
  name: string;
  category?: number;
}

const mapData = (data: ISociosChart[]) => {
  var graphData: GraphDataItem[] = [];
  data.forEach((value) => {
    graphData.push({ name: value.categoria!, y: value.cantidad!, category: value.idTipoContraparte! });
  });

  return graphData;
};

const PieChart: React.FC<PieChartProps> = ({ 
  chartName,
  data, 
  colSize = "12", 
  cantidadLabel = "Cantidad",
  chartSeriesName= "Cantidad",
  setTipoContraparteFiltrada,
  setContraparteSeleccionada
}) => {

  if (!data) {
    return null;
  }

  const graphData = mapData(data);

  var cantSocios = 0;

  data.forEach(element => {
    cantSocios += element.cantidad
  });

  const chartOptions = {
    chart: {
      type: "pie",
    },
    title: {
      text: chartName
    },
    subtitle: {
      text: `${cantidadLabel}: ${cantSocios}`
    },
    tooltip: {
      valueSuffix: ".",
    },
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: 'pointer',
        point: {
          events: {
            click: function () {
              if (!setTipoContraparteFiltrada || !setContraparteSeleccionada) {
                return
              }
              //Guardo el objeto como any para obtener las categorías
              var dataObject: any = this;
              console.log(dataObject.category)
              setTipoContraparteFiltrada(dataObject.category)
              setContraparteSeleccionada(undefined)
            }
          }
        }
      }
    },
    series: [
      {
        name: chartSeriesName,
        data: graphData,
        colorByPoint: true,
      },
    ],
    colors: [
      "#4caefe",
      "#3dc3e8",
      "#2dd9db",
      "#1feeaf",
      "#0ff3a0",
      "#00e887",
      "#23e274",
    ],
  };

  return (
    <HighChart
      colSize={colSize}
      options={chartOptions}
    />
  );
};

export default PieChart;
